export default __webpack_public_path__ + "a0cdd725d1070fe1375ba8a09603f64a.png";